import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable()
export class AlertService {
	public constructor(private alertController: AlertController) {}

	public async presentAlert(
		message: string,
		buttons: any[],
		isBackDropDismiss?: boolean,
		cssClass?: string
	): Promise<any> {
		const alertReference = await this.alertController.create({
			message,
			buttons,
			cssClass: cssClass ? cssClass : 'alert-dialog',
			backdropDismiss: isBackDropDismiss,
			mode: 'md'
		});

		return await alertReference.present();
	}

	public async presentAlertById(
		message: string,
		buttons: any[],
		alertId: string,
		isBackDropDismiss?: boolean
	): Promise<any> {
		const alertReference = await this.alertController.create({
			message,
			buttons,
			cssClass: 'alert-dialog',
			backdropDismiss: isBackDropDismiss,
			mode: 'md',
			id: alertId
		});

		return await alertReference.present();
	}

	public async dismissAlertById(alertId: string) {
		await this.alertController.dismiss(null, null, alertId);
	}
}
